<template>
    <div>
        <!-- Show when Customer Record not exists -->
        <not-found
            v-if="!Object.keys(customerDetails).length && !showPageLoader"
        ></not-found>
        <!-- Show when Customer Record not exists -->

        <!-- When data is loading -->
        <base-table-spinner
            v-if="!Object.keys(customerDetails).length && showPageLoader"
        ></base-table-spinner>
        <!-- When data is loading -->

        <div
            v-if="Object.keys(customerDetails).length"
            class="card customer-info screen-section"
        >
            <customer-information
                :show-download-modal="emailProfile ? emailProfile.status : false"
                :customer-details="customerDetails"
            ></customer-information>
        </div>
        <div
            v-if="Object.keys(customerDetails).length"
            class="filter-section sub-filter"
        >
            <h2>Risk Factor Matrix</h2>
            <div class="table-section risk-factor-table">
                <b-table :items="scoreList" :fields="scoreFields">
                    <template slot="level" slot-scope="data">
                        <base-status
                            :status-type="data.item.level"
                        ></base-status>
                    </template>
                    <template
                        v-if="scoreList.length"
                        slot="bottom-row"
                        slot-scope="data"
                    >
                        <td class="risk-factor">Base Rating</td>
                        <td class="text-center risk-score">
                            {{ customerDetails.totalScore }}
                        </td>
                        <td class="text-center risk-level">
                            <base-status
                                :status-type="customerDetails.riskLevel"
                            ></base-status>
                        </td>
                    </template>
                </b-table>
                <!-- When scoreList is loading -->
                <base-table-spinner
                    v-if="!scoreList.length && showPageLoader"
                ></base-table-spinner>
                <!-- When record not found -->
                <base-no-record-found
                    v-if="!scoreList.length && !showPageLoader"
                ></base-no-record-found>
            </div>
        </div>

        <div
            v-if="Object.keys(customerDetails).length"
            class="table-section risk-factor-table"
        >
            <b-table :items="overrideList" :fields="overrideFields">
                <template slot="level" slot-scope="data">
                    <base-status :status-type="data.item.level"></base-status>
                </template>
                <template slot="overRideTo" slot-scope="data">
                    {{
                        data.item.overRideTo
                            ? data.item.overRideTo
                            : 'N/A' | capitalize
                    }}
                </template>
                <template
                    v-if="scoreList.length"
                    slot="bottom-row"
                    slot-scope="data"
                >
                    <td class="risk-factor">Overall Rating</td>
                    <td>
                        {{ customerDetails.riskRating | capitalize }}
                    </td>
                    <td class="text-center risk-level">
                        <base-status
                            :status-type="customerDetails.riskRating"
                        ></base-status>
                    </td>
                </template>
            </b-table>
            <!-- When overrideList is loading -->
            <base-table-spinner
                v-if="!overrideList.length && showPageLoader"
            ></base-table-spinner>
            <!-- When record not found -->
            <base-no-record-found
                v-if="!overrideList.length && !showPageLoader"
            ></base-no-record-found>
        </div>
        <manual-alert-popup></manual-alert-popup>
        <cancel-review-process-popup></cancel-review-process-popup>
        <kyc-status-review-popup></kyc-status-review-popup>
    </div>
</template>
<script>
import { mapGetters } from 'vuex'
import customerInformation from '@/components/CustomerInfo.vue'
import kycStatusReviewPopup from '@/components/popups/KYCStatusReviewPopup.vue'
import manualAlertPopup from '@/components/popups/ManualAlertPopup.vue'
import cancelReviewProcessPopup from '@/components/popups/CancelReviewProcessPopup.vue'
import NotFound from '@/views/404/NotFound.vue'
import resource from '@/api/resource'
const modulesApi = new resource('configurations/modules')

import request from '@/utils/request'

export default {
    /*
    |--------------------------------------------------------------------------
    | Component > components
    |--------------------------------------------------------------------------
    */
    components: {
        customerInformation,
        kycStatusReviewPopup,
        cancelReviewProcessPopup,
        manualAlertPopup,
        NotFound,
    }, // End of Component > components

    /*
    |--------------------------------------------------------------------------
    | Component > props
    |--------------------------------------------------------------------------
    */
    props: {
        id: {
            required: true,
        },
    }, // End of Component > props

    /*
    |--------------------------------------------------------------------------
    | Component > data
    |--------------------------------------------------------------------------
    */
    data() {
        return {
            riskFactor: null,
            objIndex: null,
            showPageLoader: true,
            customerDetails: {},
            scoreFields: [],
            overrideFields: [],
            emailProfile: {},
        }
    }, // End of Component > data

    /*
    |--------------------------------------------------------------------------
    | Component > computed
    |--------------------------------------------------------------------------
    */
    computed: {
        ...mapGetters(['profile', 'dataSegmentId','dataSegmentConfigurations']),

        /**
         *
         * @return {array}
         */
        scoreList() {
            return !this.customerDetails.riskRatings
                ? []
                : this.customerDetails.riskRatings.filter((a) => {
                      return a.type === 'score'
                  })
        }, // End of scoreList() method
        /**
         *
         * @return {array}
         */
        overrideList() {
            return !this.customerDetails.riskRatings
                ? []
                : this.customerDetails.riskRatings.filter((a) => {
                      return a.type === 'override'
                  })
        }, // End of overrideList() method
    }, // End of Component > mounted
    /*
    |--------------------------------------------------------------------------
    | Component > watch
    |--------------------------------------------------------------------------
    */
    watch: {
        dataSegmentId(value) {
            if (value) {
                this.$router.push({ name: 'view-customer-profile' })
            }
        },
    }, // End of Component > methods

    /*
    |--------------------------------------------------------------------------
    | Component > mounted
    |--------------------------------------------------------------------------
    */
    mounted() {
        this.getModuleData()
        this.initializeData()
    }, // End of Component > computed
    /*
    |--------------------------------------------------------------------------
    | Component > methods
    |--------------------------------------------------------------------------
    */
    methods: {
        /**
         *
         * @return {void}
         */
        async getModuleData() {
            try {
                if (this.dataSegmentId) {
                    // let { data } = await modulesApi.list({
                    //     dataSegmentId: this.dataSegmentId,
                    // })
                    if (!_.isEmpty(this.dataSegmentConfigurations)) {
                        this.riskFactor = this.dataSegmentConfigurations.riskFactor
                        this.emailProfile = this.dataSegmentConfigurations.emailProfile
                        this.routingCondition()
                    }
                }
            } catch (error) {
                console.log(error)
            }
        },
        async initializeData() {
            this.scoreFields = this.profile.kycData.fields

            this.overrideFields = this.profile.kycData.overrideFields

            try {
                let { data } = await request({
                    url: `customers/risk-rating/${this.id}`,
                })

                this.customerDetails = data.data
                this.showPageLoader = false
            } catch (error) {
                console.log(error)
            }
            this.showPageLoader = false
        }, // End of initializeData() method
        updateData() {
            let sum = 0
            const indexes = this.customerDetails.riskRatings.reduce(
                (a, field, index) => {
                    if (
                        field.factor == 'Blacklist Hit' ||
                        field.factor == 'Nationality'
                    )
                        a.push(index)
                    return a
                },
                []
            )

            this.customerDetails.riskRatings.splice(indexes[0], indexes.length)
            this.customerDetails.riskRatings.forEach((element) => {
                sum += element.number
            })
            this.customerDetails.totalScore = sum
        },
        routingCondition() {
            if (this.riskFactor == false) {
                this.$router.push({
                    name: 'customer-information',
                    params: {
                        dataSegmentId: this.dataSegmentId,
                        token: this.$route.params.token,
                    },
                })
            }
        },
    }, // End of Component > watch
} // End of export default
</script>
